<div class="er-datepicker">
  <div class="text-grayscale-medium text-xs font-bold pl-[6px]">
    {{ label }}
  </div>
  <mat-form-field class="form-field">
    <input
      [placeholder]="placeholder"
      [disabled]="disabled"
      [matDatepicker]="picker"
      [min]="minDate"
      [max]="maxDate"
      [matDatepickerFilter]="isDateAllowed"
      matInput
      [ngModel]="value()"
      (ngModelChange)="onValueChange($event)"
    />
    <mat-datepicker-toggle matIconSuffix [for]="picker">
      <mat-icon matDatepickerToggleIcon svgIcon="calendar"></mat-icon>
    </mat-datepicker-toggle>
    <mat-datepicker #picker></mat-datepicker>
  </mat-form-field>
</div>
